<template>
  <div class="time-selector">
    <button
      class="btn justify-space-between w-200px"
      @click="isModalOpen = !isModalOpen"
    >
      <span v-if="time === ''">請選擇時間</span>
      <span v-else class="ink-01-emphasis--text">{{ time }}</span>
      <v-icon>arrow_drop_down</v-icon>
    </button>
    <div
      class="time-selector__dialog block-3 d-flex h-360px"
      v-if="isModalOpen"
    >
      <div class="time-selector__options">
        <div
          class="time-selector__option"
          v-for="hourValue in options.hour"
          :key="`hour-${hourValue}`"
          @click="setHour(hourValue)"
        >
          {{ hourValue }}
        </div>
      </div>
      <div class="time-selector__options">
        <div
          class="time-selector__option"
          v-for="minuteValue in options.minute"
          :key="`minute-${minuteValue}`"
          @click="setMinute(minuteValue)"
        >
          {{ minuteValue }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hour: {
      type: String,
      default: '',
    },
    minute: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalOpen: false,
      options: {
        hour: [...Array(24).keys()].map((i) => `${i + 1}`.padStart(2, '0')),
        minute: [...Array(60).keys()].map((i) => `${i + 1}`.padStart(2, '0')),
      },
    };
  },
  computed: {
    time() {
      const vm = this;
      if (vm.hour === '' && vm.minute === '') {
        return '';
      }
      if (vm.hour === '' && vm.minute !== '') {
        return `00:${vm.minute}`;
      }
      if (vm.hour !== '' && vm.minute === '') {
        return `${vm.hour}:00`;
      }
      return `${vm.hour}:${vm.minute}`;
    },
  },
  methods: {
    setHour(hourValue) {
      this.$emit('update:hour', hourValue);
    },
    setMinute(minuteValue) {
      this.$emit('update:minute', minuteValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.time-selector {
  position: relative;

  &__dialog {
    position: absolute;
    width: 100%;
    margin-top: 4px;
    background-color: #fff;
    z-index: 1;
  }

  &__options {
    width: 50%;
    overflow: auto;
  }
  &__option {
    padding-top: 10px;
    padding-bottom: 14px;
    padding-left: 10px;
    &:hover {
      background-color: $brand-100;
      cursor: pointer;
    }
  }
}
</style>
